/* eslint-disable no-console */
import {
  css,
  html,
  LitElement,
} from 'https://cdn.jsdelivr.net/gh/lit/dist@3/core/lit-core.min.js';

class SkioAddToSubscription extends LitElement {
  static styles = css`
    :host {
      --color-primary: #111827;
      --color-accent: #fff;
      --color-bg: #f7f2ee;
      --color-card-bg: #f5f5f5;
      --color-border: #e0e0e0;
      --color-text: #333;
      --color-muted: #666;
      --color-strikethrough: #999;
      --color-badge: #ffcf42;
      position: relative;
      display: block;
      font-family: inherit;
      font-size: 16px;
    }
    .callout {
      background: var(--color-card-bg);
      border-radius: 8px;
      padding: 24px;
      margin-bottom: 24px;
      border: 1px solid var(--color-border);
      position: relative;
    }
    .callout h3 {
      margin: 0;
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
    }
    .callout small {
      display: block;
      margin-bottom: 16px;
    }
    .callout p {
      margin: 0 0 16px 0;
      color: var(--color-muted);
      font-size: 0.9em;
    }
    .add-to-subscription-button,
    .primary-button,
    .secondary-button {
      --tw-bg-opacity: 1;
      background-color: rgb(51 51 51 / var(--tw-bg-opacity));
      --tw-text-opacity: 1;
      color: rgb(255 255 255 / var(--tw-text-opacity));
      border-radius: 9999px;
      width: 100%;
      font-size: 1rem;
      line-height: 1.5rem;
      font-weight: 600;
      cursor: pointer;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
      padding-left: 2.5rem;
      padding-right: 2.5rem;
      font-family:
        Proxima Nova,
        sans-serif;
      transition-property: color, background-color, border-color,
        text-decoration-color, fill, stroke;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration: 0.15s;
    }
    .add-to-subscription-button:hover,
    .primary-button:hover,
    .secondary-button:hover {
      --tw-bg-opacity: 1;
      background-color: rgb(82 82 82 / var(--tw-bg-opacity));
      transition-property: color, background-color, border-color,
        text-decoration-color, fill, stroke;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration: 0.15s;
    }
    dialog {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      z-index: 2147483647;
      background: var(--color-accent);
      border-radius: 12px;
      border: none;
      width: 100%;
      max-width: 500px;
      padding: 0;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
      overflow: hidden;
      box-sizing: border-box;
    }
    dialog:not([open]) {
      display: none;
    }
    dialog::backdrop {
      background: rgba(0, 0, 0, 0.5);
    }
    .modal-content {
      position: relative;
      overflow-x: hidden;
      max-width: 100%;
    }
    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      padding: 16px 32px 16px 32px;
      border-bottom: 1px solid var(--color-border);
    }
    .modal-title {
      font-size: 1.1em;
      font-weight: 700;
      color: var(--color-text);
      margin: 0;
      line-height: 1.3;
    }
    .modal-title .date-badge {
      border: 2px solid var(--color-primary);
      border-radius: 4px;
      padding: 2px 8px;
      font-size: 0.8em;
      color: var(--color-primary);
      font-weight: 500;
      background: var(--color-accent);
      display: inline-block;
    }
    .close-button {
      background: none;
      border: none;
      font-size: 2em;
      color: var(--color-muted);
      cursor: pointer;
      padding: 0;
      margin: 0;
      width: 2em;
      height: 2em;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }
    .close-button:hover {
      color: var(--color-text);
    }
    .modal-body {
      padding: 16px 32px;
      overflow-x: hidden;
    }
    .modal-body p {
      margin: 0;
      color: var(--color-muted);
      font-size: 0.9em;
      line-height: 1.5;
      max-width: 100%;
      white-space: normal;
      overflow-wrap: break-word;
    }
    form {
      padding: 24px 32px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .option-label {
      display: flex;
      align-items: center;
      gap: 8px;
      background: var(--color-card-bg);
      border: 1px solid var(--color-border);
      border-radius: 8px;
      padding: 12px;
      cursor: pointer;
      transition:
        border 0.2s,
        background 0.2s;
      position: relative;
    }
    .option-label:hover {
      border-color: var(--color-primary);
    }
    .option-label.selected {
      border: 2px solid var(--color-primary);
      background: var(--color-accent);
    }
    .option-label input[type='radio'] {
      accent-color: var(--color-primary);
      width: 1.5em;
      height: 1.5em;
      flex-shrink: 0;
    }
    .option-content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
    }
    .option-title {
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
    }
    .delivery-policy {
      font-size: 0.8em;
      color: var(--color-muted);
      font-weight: 500;
      text-transform: capitalize;
    }
    .discount-badge {
      background: var(--color-badge);
      color: var(--color-text);
      font-weight: 600;
      border-radius: 50px;
      padding: 4px 12px;
      font-size: 0.8em;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      line-height: normal;
    }
    .price-container {
      margin-left: auto;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 2px;
    }
    .original-price {
      text-decoration: line-through;
      color: var(--color-strikethrough);
      font-size: 0.9em;
      font-weight: 500;
    }
    .discounted-price {
      color: var(--color-primary);
      font-size: 1em;
      font-weight: 700;
    }
    .modal-policy {
      font-size: 0.8em;
      color: var(--color-muted);
      padding: 0px 32px 16px 32px;
      white-space: initial;
    }
    .modal-footer {
      display: flex;
      gap: 16px;
      padding: 24px 32px 32px 32px;
      border-top: 1px solid var(--color-border);
    }
    .secondary-button {
      background: transparent;
      color: var(--color-text);
      border: 2px solid var(--color-border);
    }
    .secondary-button:hover {
      background: var(--color-card-bg);
      border-color: var(--color-primary);
    }
    .success-screen {
      background: #e8f5e8;
      border: 2px solid #4caf50;
      border-radius: 8px;
      padding: 24px;
      margin-bottom: 24px;
      text-align: left;
    }
    .success-title {
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
      margin: 0 0 16px 0;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .success-message {
      font-size: 0.9em;
      color: var(--color-text);
      margin: 0 0 8px 0;
      line-height: 1.4;
    }
    .success-date {
      font-weight: 700;
      color: var(--color-text);
    }
    .success-link {
      color: var(--color-primary);
      text-decoration: none;
      font-weight: 700;
      font-size: 0.9em;
      margin-top: 16px;
      display: inline-block;
      transition: color 0.2s;
    }
    .success-link:hover {
      color: color-mix(in srgb, var(--color-primary) 80%, black);
      text-decoration: underline;
    }
    .sign-in-callout p {
      margin: 0;
    }
    .sign-in-link {
      color: var(--color-primary);
      font-weight: 700;
      text-decoration: underline;
    }
    .sign-in-link:hover {
      color: color-mix(in srgb, var(--color-primary) 80%, black);
    }
    .loading-spinner {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 2px solid var(--color-accent);
      border-radius: 50%;
      border-top-color: transparent;
      animation: spin 1s linear infinite;
      margin-right: 8px;
    }
    @keyframes spin {
      to {
        transform: rotate(360deg);
      }
    }
    .primary-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    .error-message {
      background: #fee;
      border: 1px solid #fcc;
      border-radius: 4px;
      padding: 12px;
      margin-bottom: 16px;
      color: #c33;
      font-size: 0.9em;
      text-align: center;
    }
    /* Debug / setup mode — matches plan picker's visual language */
    .setup-mode {
      padding: 16px;
      border: 5px solid transparent;
      border-image: repeating-linear-gradient(
          -55deg,
          #000 0,
          #000 20px,
          #ffb101 20px,
          #ffb101 40px
        )
        10;
      margin-bottom: 16px;
    }

    .setup-mode-label {
      font-size: 0.75em;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: #000;
      background: #ffb101;
      padding: 2px 8px;
      margin-bottom: 12px;
      display: inline-block;
    }

    .setup-mode-note {
      font-size: 0.85em;
      color: #333;
      margin: 0 0 12px 0;
    }

    .debug-mode-toggle {
      display: flex;
      gap: 8px;
      margin-bottom: 16px;
    }

    .debug-mode-toggle button {
      font-size: 0.8em;
      font-weight: 700;
      padding: 4px 12px;
      border: 2px solid #000;
      background: transparent;
      cursor: pointer;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .debug-mode-toggle button.active {
      background: #000;
      color: #fff;
    }

    .debug-modal-preview {
      border: 1px solid var(--skio-group-border-color, #e0e0e0);
      border-radius: 0;
      max-width: 500px;
      background: var(--skio-group-background-color, #fff);
      margin-top: 8px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
      overflow: hidden;
    }

    @media (max-width: 500px) {
      .modal-footer {
        flex-direction: column;
        gap: 8px;
        padding: 12px 16px 16px 16px;
      }
      .modal-header {
        padding: 12px 16px 12px 16px;
      }
      .modal-body {
        padding: 12px 16px;
      }
      form {
        padding: 12px 16px;
      }
      .modal-policy {
        padding: 0px 16px 16px 16px;
      }
    }
  `;

  static properties = {
    isLoading: { type: Boolean },
    isAuthenticated: { type: Boolean },
    productId: { type: String },
    variantId: { type: String, attribute: 'variant-id' },
    product: { type: Object },
    selectedVariant: { type: Object },
    upcomingSubscription: { type: Object },
    inactiveSubscription: { type: Object },
    failedSubscription: { type: Object },
    eligibleForSubscription: { type: Boolean },
    eligibleForOneTimeUpsell: { type: Boolean },
    selectedOption: { type: String },
    selectedSellingPlan: { type: Object },
    showSuccessScreen: { type: Boolean },
    isSubmitting: { type: Boolean },
    submitError: { type: String },
    debug: { type: Boolean },
    options: { type: String },
    debugPreviewMode: { type: String }, // "add" | "reactivate" — debug UI only
    // [added by anatta]
    ready: { type: Boolean },
    successMode: { type: String }, // 'added' | 'reactivated'
    successWasPaused: { type: Boolean },
  };

  // [added by anatta]
  get renderState() {
    if (this.showSuccessScreen) return 'success';
    if (this.ready && !this.isAuthenticated) return 'sign-in';
    return this.mode;
  }

  get signInUrl() {
    return SkioAddToSubscription.buildSignInUrl(this._options);
  }

  get signInPrompt() {
    return SkioAddToSubscription.getPrompt('sign-in', this._options);
  }

  get paymentFailedPrompt() {
    return SkioAddToSubscription.getPrompt('failed', this._options);
  }

  // [added by anatta]
  isVariantInUpcomingSubscription(variant) {
    const variantId = variant?.platformId;
    const lines = this.upcomingSubscription?.SubscriptionLines;
    if (!variantId || !Array.isArray(lines) || !lines.length) return false;
    return lines.some(
      (line) => String(line?.ProductVariant?.platformId) === String(variantId),
    );
  }

  // Parsed options from the JSON attribute (set by liquid snippet)
  get _options() {
    try {
      return JSON.parse(this.options || '{}');
    } catch {
      return {};
    }
  }

  get mode() {
    if (
      this.upcomingSubscription &&
      this.eligibleForSubscription &&
      this.selectedVariant
    )
      return 'add';
    if (this.failedSubscription) return 'failed';
    if (this.inactiveSubscription) return 'reactivate';
    return null;
  }

  constructor() {
    super();
    this.isLoading = false;
    this.isAuthenticated = false;
    this.failedSubscription = null;
    this.eligibleForSubscription = false;
    this.eligibleForOneTimeUpsell = false;
    this.selectedOption = 'subscription';
    this.showSuccessScreen = false;
    this.isSubmitting = false;
    this.submitError = null;
    this.debugPreviewMode = 'add';
    this.debug = false;
    this.isPreviewMode = false;
    // [added by anatta]
    this.ready = false;
    this.successMode = 'added';
    this.successWasPaused = false;
    this._handleActionBackdropClick = (e) => {
      if (e.target.tagName === 'DIALOG') this.closeModal();
    };
  }

  notifySubscriptionContext() {
    const detail = {
      renderState: this.renderState,
      upcomingSubscription: this.upcomingSubscription ?? null,
    };

    this.dispatchEvent(
      new CustomEvent('skio-component:context-updated', { detail }),
    );

    return detail;
  }

  async connectedCallback() {
    super.connectedCallback();
    this.isPreviewMode = !!window?.Shopify?.designMode;
    this.debug =
      this.debug ||
      this.hasAttribute('debug') ||
      Boolean(window.__SKIO_ADD_TO_SUBSCRIPTION_DEBUG__);
    if (this.isPreviewMode) return;
    await this.initialize();
    this.isLoading = false;
    this.bindFormEvents();
    // [added by anatta]
    this.ready = true;
    const context = this.notifySubscriptionContext();
    this.dispatchEvent(
      new CustomEvent('skio-component:ready', {
        detail: context,
      }),
    );
  }

  loadSDK() {
    return SkioAddToSubscription.loadSdk();
  }

  async initialize() {
    await this.loadSDK();
    await SkioAddToSubscription.waitForStorefrontUser();
    if (this.debug) {
      console.log('[Skio AddToSub] initialize:start', {
        productId: this.productId,
      });
    }

    this.isAuthenticated = Boolean(window.Skio?.storefrontUser?.id);
    if (!this.isAuthenticated) {
      if (this.debug) {
        console.log('[Skio AddToSub] initialize:guest');
      }
      return;
    }

    this.upcomingSubscription = await this.fetchSubscription('ACTIVE');

    if (this.upcomingSubscription) {
      this.product = await this.fetchProduct();
      this.applyInitialVariantSelection();
      if (this.debug) {
        console.log('[Skio AddToSub] initialize:active-subscription', {
          subscriptionId: this.upcomingSubscription.id,
          hasProduct: Boolean(this.product),
          defaultVariantPlatformId: this.selectedVariant?.platformId ?? null,
          eligibleForSubscription: this.eligibleForSubscription,
        });
      }
    } else {
      this.inactiveSubscription = await this.fetchSubscription([
        'CANCELLED',
        'PAUSED',
      ]);
      if (!this.inactiveSubscription) {
        this.failedSubscription = await this.fetchSubscription('FAILED');
      }
      if (this.debug) {
        console.log('[Skio AddToSub] initialize:inactive-subscription-check', {
          failedStatus: this.failedSubscription?.status ?? null,
          failedSubscriptionId: this.failedSubscription?.id ?? null,
          status: this.inactiveSubscription?.status ?? null,
          subscriptionId: this.inactiveSubscription?.id ?? null,
        });
      }

      if (this.inactiveSubscription && this.productId) {
        this.product = await this.fetchProduct();
        this.applyInitialVariantSelection();
      }
    }

    if (this.debug) {
      console.log('[Skio AddToSub] initialize:end', {
        hasUpcoming: Boolean(this.upcomingSubscription),
        hasInactive: Boolean(this.inactiveSubscription),
        mode: this.mode,
      });
    }
  }

  // ─── Data fetching ────────────────────────────────────────────────────────

  async fetchSubscription(status) {
    return SkioAddToSubscription.fetchSubscription(status, {
      includeLines: status === 'ACTIVE',
    });
  }

  async fetchProduct() {
    const query = `
    query Products($where: Product_bool_exp) {
      Products(where: $where) {
        title
        canUpsell
        oneTimeUpsellPercentageOff
        ProductVariants {
          enableOneTimeUpsell
          platformId
          price
          compareAtPrice
          SellingPlanGroupResources {
            SellingPlanGroup {
              customName
              SellingPlans {
                id
                platformId
                PricingPolicies {
                  percentageOff
                  fixedPrice
                }
                DeliveryPolicy {
                  interval
                  intervalCount
                }
              }
            }
          }
        }
      }
    }
  `;

    const variables = {
      where: {
        platformId: { _eq: `gid://shopify/Product/${this.productId}` },
      },
    };

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      return response.data.Products[0];
    } catch (error) {
      console.error('Error fetching product:', error);
      return null;
    }
  }

  // ─── Form / variant binding ───────────────────────────────────────────────

  applyInitialVariantSelection() {
    if (!this.product?.ProductVariants?.length) return;

    if (this.variantId) {
      this.updateSelectedVariant(this.variantId);
    } else if (!this.selectedVariant) {
      this.selectedVariant = this.product.ProductVariants[0];
    }

    this.checkVariantEligibility(this.selectedVariant);
  }

  bindFormEvents() {
    if (this.variantId) {
      this.applyInitialVariantSelection();
      this.successMode = 'added';
      this.showSuccessScreen = this.isVariantInUpcomingSubscription(
        this.selectedVariant,
      );
      this.dispatchVariantChanged();
      return;
    }

    const variantInput = this.getVariantIdInput();
    if (!variantInput) {
      if (this.debug) {
        console.log('[Skio AddToSub] bindFormEvents:no-variant-input', {
          selectedVariant: this.selectedVariant?.platformId ?? null,
        });
      }
      this.dispatchVariantChanged();
      return;
    }

    this.updateSelectedVariant(variantInput.value);
    this.checkVariantEligibility(this.selectedVariant);

    // [added by anatta]
    this.successMode = 'added';
    this.showSuccessScreen = this.isVariantInUpcomingSubscription(
      this.selectedVariant,
    );

    if (this.debug) {
      console.log('[Skio AddToSub] bindFormEvents:initial-variant', {
        variantInputValue: variantInput.value,
        selectedVariant: this.selectedVariant?.platformId ?? null,
        eligibleForSubscription: this.eligibleForSubscription,
      });
    }

    this.dispatchVariantChanged();

    variantInput.addEventListener('change', (e) => {
      this.updateSelectedVariant(e.target.value);
      this.checkVariantEligibility(this.selectedVariant);

      // [added by anatta]
      this.successMode = 'added';
      this.showSuccessScreen = this.isVariantInUpcomingSubscription(
        this.selectedVariant,
      );
      this.submitError = null;

      // [added by anatta]
      this.requestUpdate();

      this.dispatchVariantChanged();

      if (this.debug) {
        console.log('[Skio AddToSub] bindFormEvents:variant-change', {
          variantInputValue: e.target.value,
          selectedVariant: this.selectedVariant?.platformId ?? null,
          eligibleForSubscription: this.eligibleForSubscription,
        });
      }
    });
  }

  dispatchVariantChanged() {
    this.dispatchEvent(
      new CustomEvent('skio-component:variant-changed', {
        detail: {
          renderState: this.renderState,
          selectedVariant: this.selectedVariant ?? null,
          eligibleForSubscription: this.eligibleForSubscription,
          upcomingSubscription: this.upcomingSubscription ?? null,
        },
      }),
    );
  }

  /** Prefer main PDP form in this product column; first global [name=id] is often upsell/Replo. */
  getVariantIdInput() {
    // [added by anatta]
    const buyboxSelect =
      (this.closest('.js-buybox') || document).querySelector(
        '.js__buybox-variant-select-element',
      ) || document.querySelector('.js__buybox-variant-select-element');
    if (buyboxSelect) return buyboxSelect;

    const wrapper = this.closest('[data-product-form-wrapper]');
    const inColumn =
      wrapper?.querySelector('[data-product-form] input[name="id"]') ||
      wrapper?.querySelector('input[name="id"]');
    if (inColumn) return inColumn;
    return (
      document.querySelector('[data-product-form] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('[name=id]')
    );
  }

  updateSelectedVariant(variantId) {
    const id = variantId != null ? String(variantId).trim() : '';
    const variants = this.product?.ProductVariants;
    if (!variants?.length) {
      this.selectedVariant = undefined;
      return;
    }
    if (!id) {
      this.selectedVariant = variants[0];
      return;
    }
    this.selectedVariant =
      variants.find(
        (v) =>
          v.platformId?.includes(id) ||
          v.platformId?.endsWith(id) ||
          String(v.platformId) === id,
      ) || variants[0];
  }

  checkVariantEligibility(variant) {
    if (!variant) return;
    const groups = variant.SellingPlanGroupResources;
    const groupCount = Array.isArray(groups) ? groups.length : 0;
    this.eligibleForOneTimeUpsell = Boolean(
      variant.enableOneTimeUpsell && this.product?.canUpsell,
    );
    this.eligibleForSubscription = groupCount > 0;
    if (!this.eligibleForOneTimeUpsell) this.selectedOption = 'subscription';
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────

  isPrepaidSubscription(subscription) {
    return SkioAddToSubscription.isPrepaidSubscription(subscription);
  }

  formatDate(timestamp) {
    const date = new Date(timestamp);
    return `${date.toLocaleString('en-US', {
      month: 'short',
    })} ${date.getDate()}, ${date.getFullYear()}`;
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(amount);
  }

  /**
   * Shopify applies a selling plan discount to the price in cents and rounds
   * the result, so mirror that rather than letting `Intl` round at format time
   * and land a cent away from the allocation the customer is charged. Staying
   * in cents and in whole percent also keeps the arithmetic clear of the
   * binary-fraction error that pushes a half cent to the wrong side.
   */
  applyPercentageOff(amount, percentageOff) {
    const cents = Math.round(amount * 100);
    return Math.round((cents * (100 - percentageOff)) / 100) / 100;
  }

  getOriginalPrice() {
    return this.selectedVariant.compareAtPrice
      ? this.formatMoney(this.selectedVariant.compareAtPrice)
      : this.formatMoney(this.selectedVariant.price);
  }

  /**
   * Length of a delivery policy in days, or null for an interval we don't
   * recognize. The 30-day month only ever lines two cadences up against each
   * other here; it is never used to work out a date.
   */
  cadenceInDays(deliveryPolicy) {
    const daysPerInterval = { DAY: 1, WEEK: 7, MONTH: 30, YEAR: 365 };
    const days = daysPerInterval[deliveryPolicy?.interval];
    return days ? days * deliveryPolicy.intervalCount : null;
  }

  getSubscriptionPrice() {
    const subscriptionPolicy = this.upcomingSubscription.DeliveryPolicy;
    const subscriptionCadence = this.cadenceInDays(subscriptionPolicy);

    const plans = this.selectedVariant.SellingPlanGroupResources.flatMap(
      (resource) => resource.SellingPlanGroup.SellingPlans,
    );

    // Skio reports a subscription's cadence in days while its selling plans
    // keep whatever interval Shopify authored them in, so an every-week plan
    // has to be recognized as the counterpart of a 7-day subscription.
    const sellingPlan =
      plans.find(
        (plan) =>
          plan.DeliveryPolicy.interval === subscriptionPolicy.interval &&
          plan.DeliveryPolicy.intervalCount ===
            subscriptionPolicy.intervalCount,
      ) ||
      plans.find(
        (plan) =>
          subscriptionCadence !== null &&
          this.cadenceInDays(plan.DeliveryPolicy) === subscriptionCadence,
      );

    if (!sellingPlan)
      return {
        discount: null,
        price: this.formatMoney(this.selectedVariant.price),
      };

    this.selectedSellingPlan = sellingPlan;
    const { percentageOff, fixedPrice } = sellingPlan.PricingPolicies[0];

    if (percentageOff) {
      return {
        discount: `${percentageOff}%`,
        price: this.formatMoney(
          this.applyPercentageOff(this.selectedVariant.price, percentageOff),
        ),
      };
    }

    return {
      discount: this.formatMoney(fixedPrice),
      price: this.formatMoney(this.selectedVariant.price - fixedPrice),
    };
  }

  getOneTimePrice() {
    const pct = this.product.oneTimeUpsellPercentageOff;
    if (!pct)
      return {
        discount: null,
        price: this.formatMoney(this.selectedVariant.price),
      };
    // Skio states the upsell as a fraction where a selling plan states a
    // percentage, so the badge and the price work from one conversion.
    const percentageOff = pct * 100;
    return {
      discount: `${percentageOff}%`,
      price: this.formatMoney(
        this.applyPercentageOff(this.selectedVariant.price, percentageOff),
      ),
    };
  }

  // ─── Modal ────────────────────────────────────────────────────────────────

  openModal() {
    const dialog = this.shadowRoot.querySelector('dialog.action-dialog');
    if (dialog) {
      dialog.showModal();
      dialog.addEventListener('click', this._handleActionBackdropClick);
      document.body.classList.add('skio-modal-open');
    }
  }

  closeModal() {
    const dialog = this.shadowRoot.querySelector('dialog.action-dialog');
    if (dialog) {
      dialog.close();
      dialog.removeEventListener('click', this._handleActionBackdropClick);
      document.body.classList.remove('skio-modal-open');
    }
  }

  handleBackdropClick(e) {
    if (e.target.tagName === 'DIALOG') this.closeModal();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.body.classList.remove('skio-modal-open');
  }

  // ─── Actions ──────────────────────────────────────────────────────────────

  async addToSubscription() {
    this.submitError = null;
    this.isSubmitting = true;

    const mutation = `
    mutation storefrontEditSubscriptionLines($input: EditSubscriptionLinesInput!) {
      editSubscriptionLines(input: $input) {
        subscriptionId
      }
    }
  `;

    const variables = {
      input: {
        subscriptionId: this.upcomingSubscription.id,
        subscriptionLinesToCreate: [
          {
            customAttributes: [
              { key: 'add-to-subscription-component', value: 'true' },
            ],
            productVariantPlatformId: this.selectedVariant.platformId,
            quantity: 1,
            isOneTimeUpsell: this.selectedOption === 'one-time',
          },
        ],
      },
    };

    try {
      await window.Skio.graphQLRequest({ query: mutation, variables });
      this.closeModal();
      this.showSuccessScreen = true;
      // [added by anatta]
      this.successMode = 'added';
      // [added by anatta]
      if (this.upcomingSubscription) {
        const lines = this.upcomingSubscription.SubscriptionLines || [];
        const alreadyCached = lines.some(
          (line) =>
            String(line?.ProductVariant?.platformId) ===
            String(this.selectedVariant.platformId),
        );
        if (!alreadyCached) {
          this.upcomingSubscription = {
            ...this.upcomingSubscription,
            SubscriptionLines: [
              ...lines,
              {
                ProductVariant: {
                  platformId: this.selectedVariant.platformId,
                },
              },
            ],
          };
        }
      }
      this.dispatchEvent(
        new CustomEvent('skio:added', {
          detail: { subscription: this.upcomingSubscription },
        }),
      );
      this.notifySubscriptionContext();
      this.dispatchVariantChanged();
    } catch (error) {
      console.error('Error adding to subscription:', error);
      this.submitError = 'Error adding to subscription. Please try again.';
    } finally {
      this.isSubmitting = false;
    }
  }

  async reactivate() {
    this.submitError = null;
    this.isSubmitting = true;

    const isPaused = this.inactiveSubscription.status === 'PAUSED';
    const mutation = isPaused
      ? `mutation storefrontUnpauseSubscription($input: unpauseSubscriptionInput!) {
        unpauseSubscription(input: $input) { ok }
      }`
      : `mutation storefrontReactivateSubscription($input: ReactivateSubscriptionInput!) {
        reactivateSubscription(input: $input) { ok }
      }`;

    const variables = {
      input: {
        subscriptionId: this.inactiveSubscription.id,
        ...(isPaused
          ? {}
          : { newBillingDate: new Date(Date.now() + 86400000).toISOString() }),
      },
    };

    try {
      const response = await window.Skio.graphQLRequest({
        query: mutation,
        variables,
      });
      if (response.errors?.length) throw new Error(response.errors[0].message);

      const reactivated = await this.fetchSubscription('ACTIVE');
      if (!reactivated) {
        throw new Error(
          'Subscription was reactivated but could not be loaded.',
        );
      }
      this.upcomingSubscription = reactivated;
      this.inactiveSubscription = null;

      if (!this.product) this.product = await this.fetchProduct();

      // [added by anatta] Sync to the variant the customer is actually viewing.
      // In the inactive flow the product only loads now, so selectedVariant was
      // never set from the form — defaulting to ProductVariants[0] checks the
      // wrong variant and can leave mode=null (nothing renders).
      const variantInput = this.getVariantIdInput();
      this.updateSelectedVariant(variantInput?.value);
      if (this.selectedVariant)
        this.checkVariantEligibility(this.selectedVariant);

      if (
        this.selectedVariant &&
        this.eligibleForSubscription &&
        !this.isVariantInUpcomingSubscription(this.selectedVariant)
      ) {
        await this.addToSubscription();
      } else {
        // [added by anatta] Variant already in the sub (or not eligible) →
        // reactivate only. Show success instantly with the right message.
        this.successMode = 'reactivated';
        this.successWasPaused = isPaused;
        this.closeModal();
        this.showSuccessScreen = true;
      }

      this.notifySubscriptionContext();
      this.dispatchVariantChanged();
    } catch (error) {
      console.error('Error reactivating subscription:', error);
      this.submitError = 'Something went wrong. Please try again.';
    } finally {
      this.isSubmitting = false;
    }
  }

  // ─── Render ───────────────────────────────────────────────────────────────

  render() {
    if (this.isPreviewMode) return this.renderDebugMode();

    // [added by anatta] Show success regardless of mode — after reactivation
    // inactiveSubscription is cleared, so mode can be null even though we have
    // a valid success state to show.
    if (this.showSuccessScreen) return this.renderSuccessScreen();

    if (this.ready && !this.isAuthenticated) return this.renderSignInPrompt();

    if (!this.mode) return null;
    if (this.mode === 'add') return this.renderAddMode();
    if (this.mode === 'failed') return this.renderPaymentFailedPrompt();
    if (this.mode === 'reactivate') return this.renderReactivateMode();
  }

  renderAddMode() {
    const heading = 'Add to Upcoming Subscription';
    const subheading =
      'You can easily add this item to your upcoming subscription order.';
    const buttonText = 'Add to next order and save';
    return html`
      <div class="callout">
        <h3>${heading}</h3>
        <small>${subheading}</small>
        <p>
          Next order on:
          <b>${this.formatDate(this.upcomingSubscription.nextBillingDate)}</b>
        </p>
        <button class="callout-button" @click=${() => this.openModal()}>
          ${buttonText}
        </button>
      </div>

      <dialog class="action-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">
              Add to Subscription
              <span class="date-badge"
                >${this.formatDate(
                  this.upcomingSubscription.nextBillingDate,
                )}</span
              >
            </h2>
            <button class="close-button" @click=${this.closeModal}>
              &times;
            </button>
          </div>
          <form>
            ${this.submitError
              ? html`<div class="error-message">${this.submitError}</div>`
              : null}
            ${this.eligibleForOneTimeUpsell ? this.renderOneTimeOption() : null}
            ${this.eligibleForSubscription
              ? this.renderSubscriptionOption()
              : null}
          </form>
          <div class="modal-policy">
            ${this.selectedOption === 'subscription'
              ? html`<small
                  >By clicking Add to Order, you're adding this item to your
                  subscription. You'll be charged automatically at the listed
                  price and frequency until canceled.</small
                >`
              : html`<small
                  >By selecting Add to Order, you agree to a one-time charge for
                  this item, which will be added to your next subscription
                  shipment. This item will not renew or be billed again.</small
                >`}
          </div>
          <div class="modal-footer">
            <button
              class="primary-button"
              @click=${this.addToSubscription}
              ?disabled=${this.isSubmitting}
            >
              ${this.isSubmitting
                ? html`<span class="loading-spinner"></span>`
                : 'Add to Order'}
            </button>
            <button
              class="secondary-button"
              @click=${this.closeModal}
              type="button"
              ?disabled=${this.isSubmitting}
            >
              Cancel
            </button>
          </div>
        </div>
      </dialog>
    `;
  }

  renderReactivateMode() {
    const isPaused = this.inactiveSubscription.status === 'PAUSED';
    const title = isPaused
      ? 'Resume Your Subscription'
      : 'Reactivate Your Subscription';
    const description = isPaused
      ? 'Your subscription is currently paused. Resume it to receive your next order.'
      : 'Your subscription has been cancelled. Reactivate it to continue receiving your orders.';
    const buttonLabel = isPaused
      ? 'Resume Subscription'
      : 'Reactivate Subscription';

    return html`
      <div class="callout">
        <h3>${title}</h3>
        <small>${description}</small>
        <button class="callout-button" @click=${() => this.openModal()}>
          ${buttonLabel}
        </button>
      </div>

      <dialog class="action-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">${title}</h2>
            <button class="close-button" @click=${this.closeModal}>
              &times;
            </button>
          </div>
          <div class="modal-body">
            ${this.submitError
              ? html`<div class="error-message">${this.submitError}</div>`
              : null}
            <p>
              ${isPaused
                ? 'Your subscription will be resumed and your next order will be scheduled automatically.'
                : 'Your subscription will be reactivated and your next order will be scheduled automatically.'}
            </p>
          </div>
          <div class="modal-footer">
            <button
              class="primary-button"
              @click=${this.reactivate}
              ?disabled=${this.isSubmitting}
            >
              ${this.isSubmitting
                ? html`<span class="loading-spinner"></span>`
                : buttonLabel}
            </button>
            <button
              class="secondary-button"
              @click=${this.closeModal}
              type="button"
              ?disabled=${this.isSubmitting}
            >
              Cancel
            </button>
          </div>
        </div>
      </dialog>
    `;
  }

  renderOneTimeOption() {
    const { discount, price } = this.getOneTimePrice();
    const isSelected = this.selectedOption === 'one-time';
    const title = 'Get One-Time';

    return html`
      <label
        class="option-label ${isSelected ? 'selected' : ''}"
        @click=${() => (this.selectedOption = 'one-time')}
      >
        <input
          type="radio"
          name="addType"
          value="one-time"
          .checked=${isSelected}
          @change=${() => (this.selectedOption = 'one-time')}
        />
        <div class="option-content">
          <span class="option-title">${title}</span>
        </div>
        ${discount
          ? html`<span class="discount-badge">Save ${discount}</span>`
          : null}
        <div class="price-container">
          ${this.getOriginalPrice() !== price
            ? html`<span class="original-price"
                >${this.getOriginalPrice()}</span
              >`
            : null}
          <span class="discounted-price">${price}</span>
        </div>
      </label>
    `;
  }

  renderSubscriptionOption() {
    const { discount, price } = this.getSubscriptionPrice();
    const isSelected = this.selectedOption === 'subscription';
    const title = 'Subscribe';

    return html`
      <label
        class="option-label ${isSelected ? 'selected' : ''}"
        @click=${() => (this.selectedOption = 'subscription')}
      >
        <input
          type="radio"
          name="addType"
          value="subscription"
          .checked=${isSelected}
          @change=${() => (this.selectedOption = 'subscription')}
        />
        <div class="option-content">
          <span class="option-title">${title}</span>
          <div class="delivery-policy">
            Every ${this.upcomingSubscription.DeliveryPolicy.intervalCount}
            ${this.upcomingSubscription.DeliveryPolicy.interval.toLowerCase()}
          </div>
        </div>
        ${discount
          ? html`<span class="discount-badge">Save ${discount}</span>`
          : null}
        <div class="price-container">
          ${this.getOriginalPrice() !== price
            ? html`<span class="original-price"
                >${this.getOriginalPrice()}</span
              >`
            : null}
          <span class="discounted-price">${price}</span>
        </div>
      </label>
    `;
  }

  renderSignInPrompt() {
    const { message, linkText, href } = this.signInPrompt;

    return html`
      <div class="callout sign-in-callout">
        <p>
          ${message}
          <a class="sign-in-link" href=${href}>${linkText}</a>
        </p>
      </div>
    `;
  }

  renderPaymentFailedPrompt() {
    const { linkText, href, message } = this.paymentFailedPrompt;

    return html`
      <div class="callout sign-in-callout">
        <p>
          <a class="sign-in-link" href=${href}>${linkText}</a>
          ${message}
        </p>
      </div>
    `;
  }

  renderSuccessScreen() {
    // [added by anatta] Drive the message off explicit success context, not
    // mode/inactiveSubscription (both already cleared after reactivation).
    const isReactivate = this.successMode === 'reactivated';
    const isPaused = this.successWasPaused;

    if (isReactivate) {
      return html`
        <div class="success-screen">
          <h2 class="success-title">
            ${isPaused ? 'Subscription Resumed' : 'Subscription Reactivated'}
          </h2>
          <p class="success-message">
            Your subscription has been ${isPaused ? 'resumed' : 'reactivated'}.
            Your next order will be processed on the next scheduled billing
            date.
          </p>
          <a href="/a/account/subscriptions" class="success-link"
            >View and manage my subscriptions -></a
          >
        </div>
      `;
    }

    return html`
      <div class="success-screen">
        <h2 class="success-title">Added to Your Next Order</h2>
        <p class="success-message">
          This item will be included in your next subscription order shipment on
          <span class="success-date"
            >${this.formatDate(this.upcomingSubscription.nextBillingDate)}</span
          >
        </p>
        <a href="/a/account/subscriptions" class="success-link"
          >View and manage my subscriptions -></a
        >
      </div>
    `;
  }

  renderDebugMode() {
    const mockDate = new Date();
    mockDate.setDate(mockDate.getDate() + 30);
    const formattedDate = this.formatDate(mockDate);

    const heading = 'Add to Upcoming Subscription';
    const subheading =
      'You can easily add this item to your upcoming subscription order.';
    const buttonText = 'Add to next order and save';
    const oneTimeTitle = 'Get One-Time';
    const subscriptionTitle = 'Subscribe';

    return html`
      <div class="setup-mode">
        <div class="setup-mode-label">
          Setup Mode — Skio Add to Subscription
        </div>
        <p class="setup-mode-note">
          UI preview with mock data. Functionality requires an authenticated
          customer with an active or inactive subscription.
        </p>

        <div class="debug-mode-toggle">
          <button
            class="${this.debugPreviewMode === 'add' ? 'active' : ''}"
            @click=${() => (this.debugPreviewMode = 'add')}
            type="button"
          >
            Add Mode
          </button>
          <button
            class="${this.debugPreviewMode === 'reactivate' ? 'active' : ''}"
            @click=${() => (this.debugPreviewMode = 'reactivate')}
            type="button"
          >
            Reactivate Mode
          </button>
        </div>

        ${this.debugPreviewMode === 'add'
          ? html`
              <div class="callout" style="margin-bottom: 16px;">
                <h3>${heading}</h3>
                <small>${subheading}</small>
                <p>Next order on: <b>${formattedDate}</b></p>
                <button class="callout-button" type="button">
                  ${buttonText}
                </button>
              </div>

              <div class="debug-modal-preview">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2 class="modal-title">
                      Add to Subscription
                      <span class="date-badge">${formattedDate}</span>
                    </h2>
                    <button class="close-button" type="button">&times;</button>
                  </div>
                  <form>
                    <label class="option-label">
                      <input type="radio" name="addType" value="one-time" />
                      <div class="option-content">
                        <span class="option-title">${oneTimeTitle}</span>
                      </div>
                      <span class="discount-badge">Save 10%</span>
                      <div class="price-container">
                        <span class="original-price">$34.99</span>
                        <span class="discounted-price">$31.49</span>
                      </div>
                    </label>
                    <label class="option-label selected">
                      <input
                        type="radio"
                        name="addType"
                        value="subscription"
                        checked
                      />
                      <div class="option-content">
                        <span class="option-title">${subscriptionTitle}</span>
                        <div class="delivery-policy">Every 30 days</div>
                      </div>
                      <span class="discount-badge">Save 15%</span>
                      <div class="price-container">
                        <span class="original-price">$34.99</span>
                        <span class="discounted-price">$29.74</span>
                      </div>
                    </label>
                  </form>
                  <div class="modal-policy">
                    <small
                      >By clicking Add to Order, you're adding this item to your
                      subscription. You'll be charged automatically at the
                      listed price and frequency until canceled.</small
                    >
                  </div>
                  <div class="modal-footer">
                    <button class="primary-button" type="button">
                      Add to Order
                    </button>
                    <button class="secondary-button" type="button">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            `
          : html`
              <div class="callout" style="margin-bottom: 16px;">
                <h3>Resume Your Subscription</h3>
                <small
                  >Your subscription is currently paused. Resume it to receive
                  your next order.</small
                >
                <button class="callout-button" type="button">
                  Resume Subscription
                </button>
              </div>

              <div class="debug-modal-preview">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2 class="modal-title">Resume Your Subscription</h2>
                    <button class="close-button" type="button">&times;</button>
                  </div>
                  <div class="modal-body">
                    <p>
                      Your subscription will be resumed and your next order will
                      be scheduled automatically.
                    </p>
                  </div>
                  <div class="modal-footer">
                    <button class="primary-button" type="button">
                      RESUME SUBSCRIPTION
                    </button>
                    <button class="secondary-button" type="button">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            `}
      </div>
    `;
  }

  static PROMPT_DEFAULTS = {
    signInMessage: 'Want to add this item to your upcoming subscription?',
    signInLinkText: 'Sign in',
    paymentFailedLinkText: 'Visit your account',
    paymentFailedMessage: 'to update your credit card information.',
  };

  static THEME_PROMPT_LINK_CLASS =
    'font-semibold text-gray-900 underline decoration-1 underline-offset-2';

  static parseOptions(optionsJson) {
    try {
      return JSON.parse(optionsJson || '{}');
    } catch {
      return {};
    }
  }

  static buildSignInUrl(options = {}) {
    const base =
      options.signInUrl ||
      `${window.Shopify?.routes?.root || '/'}a/account/login`;
    const returnUrl = encodeURIComponent(
      `${window.location.pathname}${window.location.search}`,
    );
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}return_url=${returnUrl}`;
  }

  static getPrompt(state, options = {}) {
    const defaults = SkioAddToSubscription.PROMPT_DEFAULTS;
    if (state === 'sign-in') {
      return {
        message: options.signInMessage || defaults.signInMessage,
        linkText: options.signInLinkText || defaults.signInLinkText,
        href: SkioAddToSubscription.buildSignInUrl(options),
      };
    }
    if (state === 'failed') {
      const root = window.Shopify?.routes?.root || '/';
      return {
        linkText:
          options.paymentFailedLinkText || defaults.paymentFailedLinkText,
        href: options.paymentFailedUrl || `${root}a/account/subscriptions`,
        message: options.paymentFailedMessage || defaults.paymentFailedMessage,
      };
    }
    return null;
  }

  static renderThemePrompt(container, state, options = {}) {
    if (!container) return;
    const prompt = SkioAddToSubscription.getPrompt(state, options);
    if (!prompt) {
      container.classList.add('hidden');
      container.innerHTML = '';
      return;
    }

    const linkClass = SkioAddToSubscription.THEME_PROMPT_LINK_CLASS;
    container.innerHTML =
      state === 'failed'
        ? `<a href="${prompt.href}" class="${linkClass}">${prompt.linkText}</a> ${prompt.message}`
        : `${prompt.message} <a href="${prompt.href}" class="${linkClass}">${prompt.linkText}</a>`;
    container.classList.remove('hidden');
  }

  static loadSdk() {
    if (window.Skio) return Promise.resolve();
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.skio.com/scripts/shopify/sdk/skio-latest.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  static isLikelyLoggedInShopifyCustomer() {
    return typeof window.__nuts_external_id__ !== 'undefined';
  }

  static async waitForStorefrontUser(timeout = 8000) {
    if (window.Skio?.storefrontUser?.id) return true;
    if (!SkioAddToSubscription.isLikelyLoggedInShopifyCustomer()) {
      return false;
    }

    const started = Date.now();
    while (Date.now() - started < timeout) {
      if (window.Skio?.storefrontUser?.id) return true;
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    return Boolean(window.Skio?.storefrontUser?.id);
  }

  static async fetchSubscription(status, { includeLines = false } = {}) {
    const statusFilter = Array.isArray(status)
      ? { _in: status }
      : { _eq: status };

    const isActive = status === 'ACTIVE';
    const storefrontUserId = window.Skio?.storefrontUser?.id;
    const storefrontUserFilter = storefrontUserId
      ? `
        storefrontUserId: { _eq: $storefrontUserId }`
      : '';

    const query = `
    query storefrontGetSubscription($storefrontUserId: uuid) {
      Subscriptions(where: {
        status: ${JSON.stringify(statusFilter).replace(/"([^"]+)":/g, '$1:')}
        ${storefrontUserFilter}
      }, order_by: {
        ${isActive ? 'nextBillingDate' : 'updatedAt'}: asc
      }, limit: 1) {
        id
        status
        nextBillingDate
        ${
          isActive && includeLines
            ? `
        SubscriptionLines(
          where: { removedAt: { _is_null: true } }
          order_by: { createdAt: asc }
        ) {
          ProductVariant {
            platformId
          }
          OriginalSellingPlan {
            PricingPolicies {
              percentageOff
              fixedPrice
            }
          }
        }`
            : ''
        }
        DeliveryPolicy {
          interval
          intervalCount
        }
        BillingPolicy {
          interval
          intervalCount
        }
      }
    }
  `;

    const variables = storefrontUserId ? { storefrontUserId } : {};

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      const subscription = response?.data?.Subscriptions?.[0];
      if (!subscription) return null;
      if (
        isActive &&
        SkioAddToSubscription.isPrepaidSubscription(subscription)
      ) {
        return null;
      }
      return subscription;
    } catch (error) {
      console.error('Error fetching subscription:', error);
      return null;
    }
  }

  static isPrepaidSubscription({ DeliveryPolicy, BillingPolicy }) {
    return (
      DeliveryPolicy.interval !== BillingPolicy.interval ||
      DeliveryPolicy.intervalCount !== BillingPolicy.intervalCount
    );
  }

  static async resolveSubscriptionContext() {
    await SkioAddToSubscription.loadSdk();
    await SkioAddToSubscription.waitForStorefrontUser();

    if (!window.Skio?.storefrontUser?.id) {
      return { renderState: 'sign-in', upcomingSubscription: null };
    }

    const upcomingSubscription = await SkioAddToSubscription.fetchSubscription(
      'ACTIVE',
      { includeLines: true },
    );
    if (upcomingSubscription) {
      return { renderState: 'add', upcomingSubscription };
    }

    const inactiveSubscription = await SkioAddToSubscription.fetchSubscription([
      'CANCELLED',
      'PAUSED',
    ]);
    if (inactiveSubscription) {
      return { renderState: 'reactivate', upcomingSubscription: null };
    }

    const failedSubscription =
      await SkioAddToSubscription.fetchSubscription('FAILED');
    if (failedSubscription) {
      return { renderState: 'failed', upcomingSubscription: null };
    }

    return { renderState: null, upcomingSubscription: null };
  }

  static async addVariantToSubscription({
    subscriptionId,
    variantId,
    quantity = 1,
  }) {
    await SkioAddToSubscription.loadSdk();

    const mutation = `
    mutation storefrontEditSubscriptionLines($input: EditSubscriptionLinesInput!) {
      editSubscriptionLines(input: $input) {
        subscriptionId
      }
    }
  `;

    const variables = {
      input: {
        subscriptionId,
        subscriptionLinesToCreate: [
          {
            customAttributes: [
              { key: 'add-to-subscription-component', value: 'true' },
              { key: 'added-from-cart', value: 'true' },
            ],
            productVariantPlatformId: `gid://shopify/ProductVariant/${variantId}`,
            quantity,
            isOneTimeUpsell: false,
          },
        ],
      },
    };

    const response = await window.Skio.graphQLRequest({
      query: mutation,
      variables,
    });
    if (response?.errors?.length) {
      throw new Error(response.errors[0].message);
    }
  }
}

customElements.define('skio-add-to-subscription', SkioAddToSubscription);
